module.exports = __webpack_public_path__ + "img/189.7eb29f6c.jpg";